import { FooterContainer } from '../../styles/Layout.style'
import { 
  ContactContainer, 
  Box, 
  LogosContainer, 
  CopyRightContainer, 
  SocialLogosContainer, 
  ImageSection,
  Container, Spacer } from './Footer.style'
import EuphaLogoWhite from '../../assets/eupha-white.png'
import HelixorLogo from '../../assets/helixor-white.png'
import MesoterLogo from '../../assets/mesoter-white.png'
import RegenhialLogo from '../../assets/regenhial-white.png'
import SymbioLogo from '../../assets/symbiopharm-white.png'
import DrReck from '../../assets/dr-white.png'
import KvpLogo from '../../assets/kvp-white.png'
import TegorLogo from '../../assets/tegor-white.png'
import { IoLogoWhatsapp } from 'react-icons/io'
import { BiLogoInstagramAlt } from 'react-icons/bi'
import { FaFacebookF } from 'react-icons/fa'
import BackgroundFooter from '../../assets/background-footer.png'

const Footer = () => {
  return (
    <FooterContainer>
      <Container>
      <ContactContainer>
        <Box>
          <p>Datos del contacto</p>
          <p>11 Avenida 15-11 Zona 10, Guatemala C.A.</p>
          <p>(+502) 4220 2493</p>
          <Spacer />
          <p>Boulevard Constitución No. 543, San Salvador</p>
          <p>(+503) 2213 9980</p>
          <Spacer />
          <SocialLogosContainer>
            <a href="https://wa.link/64bjxc"><IoLogoWhatsapp /></a>
            <a href="https://www.instagram.com/eupha.pharma/"><BiLogoInstagramAlt /></a>
            <a href="https://www.facebook.com/profile.php?id=61561232162304"><FaFacebookF /></a>
          </SocialLogosContainer>
        </Box>
        <Box>
          <p>Horario</p>
          <p>Lunes a viernes de 8:00 am a 6:00 pm</p>
          <p>Sábado y domingo: cerrado</p>
        </Box>
        <Box>
          <img src={EuphaLogoWhite} />
        </Box>
      </ContactContainer>
      <LogosContainer>
        <img src={HelixorLogo} />
        <img src={MesoterLogo} />
        <img src={RegenhialLogo} />
        <img src={SymbioLogo} />
        <img src={DrReck} />
        <img src={KvpLogo} />
        <img src={TegorLogo} />
      </LogosContainer>
      <CopyRightContainer>
        <p>Copyright © Eupha 2024 | Todos los derechos reservados</p>
      </CopyRightContainer>
      </Container>
      <ImageSection>
        <img src={BackgroundFooter} />
      </ImageSection>
    </FooterContainer>
  )
}

export default Footer